<template></template>
<script>
export default {
  beforeCreate() {},
  mounted() {
    
  },
  data() {
    return{}
  },
  methods: {
    loadAirKiss(){
      var that = this;
      that.isSpinShow = true;
      var thisUrl = encodeURIComponent(location.href);
      $.ajax({
        url: "/api/getJsapiConfig?thisUrl=" + thisUrl,
        contentType: "application/json",
        type: "get",
        async: true,
        dataType: "json",
        success: function(receiveData) {
          if (receiveData.body == null) {
            return;
          }
          wx.config({
            beta: true, // 开启内测接口调用，注入wx.invoke方法
            debug: false, // 开启调试模式，关闭
            appId: receiveData.body.appId, // 必填，公众号的唯一标识
            timestamp: receiveData.body.timestamp, // 必填，生成签名的时间戳
            nonceStr: receiveData.body.nonceStr, // 必填，生成签名的随机串
            signature: receiveData.body.signature, // 必填，签名
            jsApiList: ["configWXDeviceWiFi"] // 需要使用的jsapi列表
          });
      
          wx.ready(function() {
            wx.checkJsApi({
              jsApiList: ["configWXDeviceWiFi"],
              success: function(res) {
                wx.invoke("configWXDeviceWiFi", {}, function(res) {
                  var err_msg = res.err_msg;
                  console.log(err_msg);
                  if (err_msg == "configWXDeviceWiFi:ok") {
                    console.log("ok");
                    return;
                  } else {
                    console.log("no");
                  }
                });
              }
            });
          });
          console.log(receiveData);
        },
        error: function(textStatus) {
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        },
        complete: function(XMLHttpRequest, textStatus) {
          that.isSpinShow = false;
        }
      });
    }
  }
};
</script>
<style scope>
</style>

